module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAuCAYAAABnNToWAAAABGdBTUEAALGPC/xhBQAAAGZJREFUaAXt1zEKACAMA0Dx0T7dVX2Bm5DiCU6CtJcprTkECLwSGOfjFXjnbeF+e6z4ZqGKqZmZAAECBAgQIECgvoA+lJChPpSQghkIECBAgAABAgT+E9CHEjLXhxJSMAMBAgT+Fdh3IHLoBRR6mQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/Layout/hamburger.png
// module id = ./assets/Layout/hamburger.png
// module chunks = 168707334958949